export default __webpack_public_path__ + "media/images/payconiq-bab08f5a9ee4edb0503089bc195cdf68.png";